module.exports = __webpack_public_path__ + "img/pin-assistant.56dca51.png";